
<mat-spinner class="hourglass" *ngIf="show_hourglass"></mat-spinner>


<div class="loading-overlay" *ngIf="loading_progress>0">
  <div class="loading-content">
    <div class="title-appli">{{appliname}}</div>
    <span class="loading-message">{{loading_message}}</span>
    <div class="progress-bar">
      <div class="progress-fill" [style.width.%]="loading_progress"></div>
    </div>
    <span class="loading-percent">{{loading_progress}}%</span>
  </div>
</div>



<div class="main-container">
  <div *ngIf="!show_toolbar" style="display: flex;">
    <div style="font-size:large;font-weight:bold;padding:10px;text-align: center;">{{title}}</div>
    <div *ngIf="increment_periode!='aucun'">
      <button mat-icon-button (click)="changePeriod(-1, $event)"
              title="{{increment_periode}} précédent(e)">
        <mat-icon>keyboard_double_arrow_left</mat-icon>
      </button>
      <button mat-icon-button style="margin-top: 10px;" (click)="changePeriod(1, $event)"
              title="{{increment_periode}} suivant(e)">
        <mat-icon>keyboard_double_arrow_right</mat-icon>
      </button>
    </div>

    <button mat-icon-button
            title="Légende des couleurs"
            [matMenuTriggerFor]="legende">
      <mat-icon>format_list_numbered</mat-icon>
    </button>
    <mat-menu #legende="matMenu">
      <div style="padding-left: 5px;padding: 3px;"
           *ngFor="let filter of filters[ColumnColor]"
           [style.background-color]="colorPalette[filters[ColumnColor].indexOf(filter)]">
        {{ColumnColor+": "+filter}}
      </div>
    </mat-menu>
  </div>


  <div class="header-main" *ngIf="show_toolbar">

    <button mat-icon-button style="margin-top:-15px;"
            id="quick_period"
            title="Accès rapide à une liste de plage prédéfinie"
            [matMenuTriggerFor]="menu">
      <mat-icon>calendar_month</mat-icon>
    </button>


    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onPeriodSelect('currentDay')">Aujourd'hui</button>
      <button mat-menu-item (click)="onPeriodSelect('currentYear')">Année courante</button>
      <button mat-menu-item (click)="onPeriodSelect('currentScholarYear')">Année scolaire</button>
      <button mat-menu-item (click)="onPeriodSelect('currentMonth')">Mois courant</button>
      <button mat-menu-item (click)="onPeriodSelect('currentWeek')">Semaine courante</button>
      <button mat-menu-item (click)="onPeriodSelect('currentSemestre')">Semestre courant</button>
    </mat-menu>


    <mat-form-field class="period-set" id="select_period"
                    title="Définie la plage de date (début et fin) du calendrier"
                    *ngIf="!isMobile">
      <mat-label>Période affichée</mat-label>
      <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
        <input matStartDate formControlName="start" (dateChange)="onPeriodeChange()">
        <input matEndDate formControlName="end"  (dateChange)="onPeriodeChange()">
      </mat-date-range-input>

      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>

      @if (range.controls.start.hasError('matStartDateInvalid')) {
        <mat-error>Invalid start date</mat-error>
      }
      @if (range.controls.end.hasError('matEndDateInvalid')) {
        <mat-error>Invalid end date</mat-error>
      }
    </mat-form-field>



    <div *ngIf="increment_periode!='aucun'"
         style="text-align: center;margin-top: -20px;" id="next_period"
          title="Permet de passer à la plage calendaire suivante ou précédente. En maintenant la touche shift enfoncée, on va directement à une plage non vide">
      <button mat-icon-button  (click)="changePeriod(-1, $event)"
              title="{{increment_periode}} précédent(e). Maintenir CTRL pour reculer jusqu'aux prochains cours">
        <mat-icon>keyboard_double_arrow_left</mat-icon>
      </button>
      <button mat-icon-button style="margin-top:-10px;margin-left: -10px;" (click)="changePeriod(1, $event)"
              title="{{increment_periode}} suivant(e). Maintenir CTRL pour avancer jusqu'aux prochains cours">
        <mat-icon>keyboard_double_arrow_right</mat-icon>
      </button>
    </div>


    <mat-form-field id="entete_principal" class="column-list" title="Titre principal des colonnes du calendrier">
      <mat-label>Entête principal</mat-label>
      <mat-select [(ngModel)]="columnHeaderName" (selectionChange)="onColumnChange(columnHeaderName)">
        <mat-option *ngFor="let elt of filter_values(columnHeaderNames,filter_header1)" [value]="elt">{{elt}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="column-list" title="Deuxième niveau d'entete des colonnes du calendrier" id="entete_secondaire" >
      <mat-label>Entête secondaire</mat-label>
      <mat-select [(ngModel)]="subColumnHeaderName" (selectionChange)="onColumnChange(subColumnHeaderName)">
        <mat-option *ngFor="let elt of filter_values(subColumnHeaderNames,filter_header2)" [value]="elt">{{elt}}</mat-option>
      </mat-select>
      <mat-icon matIconSuffix (click)="clear_sub_header($event)" title="Supprimer le sous entête">cancel</mat-icon>
    </mat-form-field>


    <mat-form-field *ngIf="!isMobile"
                    class="column-list" id="coloration-field"
                    title="Détermine la coloration de l'événement en fonction de la propriété sélectionnée">
      <mat-label>Coloration</mat-label>
      <mat-select id="coloration-select" [(ngModel)]="ColumnColor" (selectionChange)="onColumnColorChange()">
        <mat-option *ngFor="let elt of ColumnColorValues" [value]="elt">{{elt}}</mat-option>
      </mat-select>
      <mat-icon matIconSuffix (click)="clear_color($event)" title="Supprimer le sous entête">cancel</mat-icon>
      <mat-icon matIconPrefix
                (click)="open_legende($event)"
                id="color_legende"
                *ngIf="ColumnColor"
                title="Légende des couleurs utilisée pour les cours"
                [matMenuTriggerFor]="legende2">format_list_numbered</mat-icon>
    </mat-form-field>

    <mat-menu #legende2="matMenu">
      <div style="padding-left: 5px;padding: 3px;"
           *ngFor="let filter of filters[ColumnColor]"
           [style.background-color]="colorPalette[filters[ColumnColor].indexOf(filter)]">
        {{ColumnColor+": "+filter}}
      </div>
    </mat-menu>

    <div style="margin-top: -17px;" *ngIf="isEmptyColumn()" id="condense"
         title="Supprime les colonnes de niveau 1 si elles sont vides">
      <div style="margin-bottom: 3px;font-size: small;">Condenser</div>
      <mat-slide-toggle [(ngModel)]="removeEmptyColumns"
                        (change)="onColumnChange()">
      </mat-slide-toggle>
    </div>

    <button title="Efface tous les filtres"
            *ngIf="JSON.stringify(selectedFilter)!='{}'"
            mat-icon-button (click)="clearFilters()" style="margin-top:-15px;">
      <mat-icon>delete</mat-icon>
    </button>

    <app-tuto
      (click)="open_help()"
      [autostart]="1"
      ids="tuto/Diapositive1.JPG|tuto/Diapositive2.JPG|time_col|quick_period|select_period|next_period|entete_principal|entete_secondaire|coloration-field|color_legende|condense|burger_menu|tuto/Diapositive3.JPG">
    </app-tuto>

    <div style="flex-grow: 1;" *ngIf="!show_masks"></div>

    <mat-form-field *ngIf="!isMobile && show_masks" style="flex-grow: 1;">
      <mat-label>Masque des événements</mat-label>
      <input matInput [(ngModel)]="eventDisplayMask" placeholder="{nom_de_propriété}"
             (ngModelChange)="update_url()"
             [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let mask of maskSuggestions" [value]="mask">
          {{mask}}
        </mat-option>
      </mat-autocomplete>
      <mat-icon matIconSuffix (click)="clear_sub_header($event)"
                title="{date} affiche le début de la séance, {plage} affiche le créneau horaire, {titre} {salle} {prof}">
        help
      </mat-icon>
    </mat-form-field>



    <!-- Burger Menu Button -->
    <button mat-icon-button style="margin-top:-20px;" (click)="toggleSidePanel()"
            title="Ouvrir le menu latéral contenant certains paramétrages, les filtres et les exportations"
            id="burger_menu"
            *ngIf="burger_menu">
      <mat-icon>menu</mat-icon>
    </button>


    <!--      <mat-form-field class="tag-filter">-->
    <!--        <mat-label>Event content</mat-label>-->
    <!--        <mat-select multiple [(ngModel)]="event_label" (selectionChange)="onEventLabelChange()">-->
    <!--          <mat-option *ngFor="let item of columnHeaderNames" [value]="item">{{item}}</mat-option>-->
    <!--        </mat-select>-->
    <!--      </mat-form-field>-->

    <!--      La zone de filtre -->


  </div>

  <div class="calendar-container">
    <!--  <full-calendar [options]="calendarOptions"></full-calendar>-->

    <app-flexible-calendar
      [columnHeaderName]="[columnHeaderName,subColumnHeaderName]"
      [all_headers]="columns"
      [startTime]="startTime"
      [endTime]="endTime"
      (fire_context_menu)="context_menu($event)"
      (fire_open)="fire_open($event)"
      (get_capture)="update_capture($event)"
      (fire_entete)="remove_from_filter($event)"
      [events]="filteredEvents"
      [eventDisplayMask]="eventDisplayMask"
      [eventDisplayInfoBulle]="eventDisplayInfoBulle">
    </app-flexible-calendar>

  </div>

  <br>

</div>


@if (isSidePanelOpen) {
  <app-tuto [autostart]="1"
            ids="filter_zone|cmdShare|cmdCopy|cmdExcel|cmdPrint|cmdTheme"></app-tuto>
} @else {
<!--  <div class="side-panel-overlay" (click)="toggleSidePanel()"></div>-->
}

<!-- Side Panel Overlay -->


<!-- Side Panel -->
<div class="side-panel" [class.open]="isSidePanelOpen">
  <div class="side-panel-header">
    <h4>Filtrage et propriétés</h4>
    <button mat-icon-button (click)="toggleSidePanel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>




<!--  Menu lateral ************************************************************************-->

  <div class="side-panel-content">

    <mat-form-field class="event-mask-input" *ngIf="show_masks">
      <mat-label>Masque des événements</mat-label>
      <input matInput [(ngModel)]="eventDisplayMask"
             (ngModelChange)="update_url()"
             placeholder="{nom_de_propriété}" [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let mask of maskSuggestions" [value]="mask">
          {{mask}}
        </mat-option>
      </mat-autocomplete>
      <mat-icon matIconSuffix (click)="clear_sub_header($event)"
                title="{date} affiche le début de la séance, {plage} affiche le créneau horaire, {titre} {salle} {prof}">
        help
      </mat-icon>
    </mat-form-field>
    <br>

    <mat-form-field class="event-mask-input" *ngIf="show_masks">
      <mat-label>Masque info bulle</mat-label>
      <input matInput [(ngModel)]="eventDisplayInfoBulle"
             (ngModelChange)="update_url()"
             placeholder="{nom_de_propriété}" [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let mask of maskSuggestions" [value]="mask">
          {{mask}}
        </mat-option>
      </mat-autocomplete>
      <mat-icon matIconSuffix (click)="clear_sub_header($event)"
                title="{date} affiche le début de la séance, {plage} affiche le créneau horaire, {titre} {salle} {prof}">
        help
      </mat-icon>
    </mat-form-field>
    <br>


    <mat-form-field class="side-panel-input">
      <mat-label>Parcours du calendrier par</mat-label>
      <mat-select [(ngModel)]="increment_periode" (selectionChange)="alert_message(this,'changement de pas')" >
        <mat-option value="aucun">Pas de parcours</mat-option>
        <mat-option value="jour">Jour</mat-option>
        <mat-option value="semaine">Semaine</mat-option>
        <mat-option value="mois">Mois</mat-option>
        <mat-option value="année">Année</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="isMobile" class="side-panel-input" style="width: 100%;">
      <mat-label>Coloration</mat-label>
      <mat-select [(ngModel)]="ColumnColor" (selectionChange)="onColumnColorChange()">
        <mat-option *ngFor="let elt of subColumnHeaderNames" [value]="elt">{{elt}}</mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field class="side-panel-input" title="Changer de calendrier" *ngIf="show_sources">
      <mat-label>Sources</mat-label>
      <mat-select [(ngModel)]="source" (selectionChange)="onSourceChange()">
        <mat-option value="json">Démo</mat-option>
        <mat-option value="oasis_homolo">OASIS Homolo</mat-option>
        <mat-option value="oasis">OASIS</mat-option>
        <mat-option value="upload">Upload</mat-option>
        <mat-option value="calendar">Google Calendar</mat-option>
      </mat-select>
    </mat-form-field>


    <input type="file" #fileUpload style="display: none"
           (change)="handleFileInput($event.target!.files)"/>


    <div class="filter-zone" id="filter_zone"
         title="Sélectionner des valeurs dans les filtres pour réduire le nombre d'événements affichés">
      <h4 style="width: 100%;">
        Filtrer par
        <mat-icon style="font-size: medium;margin-bottom: -10px;" matIconPrefix title="Vous pouvez utiliser le clavier sur la première lettre pour accéder directement aux valeurs de la liste">help</mat-icon>
      </h4>

      <mat-form-field class="prop-filter" [title]="'Filtrer les cours sur '+prop"
                      *ngFor="let prop of filter_values(columnHeaderNames,filter_filterValue)"
                      [style.display]="prop!=subColumnHeaderName && filters[prop] && filters[prop].length>0 ? 'flex':'none'">
        <mat-label>{{prop}}</mat-label>
        <mat-select multiple [(ngModel)]="selectedFilter[prop]" (selectionChange)="onFilterChange()" >
          <mat-option *ngFor="let tag of filters[prop] || []" [value]="tag"
                      [style.background-color]="get_color_filter(tag,prop)">{{tag}}</mat-option>
        </mat-select>
        <mat-icon matIconSuffix (click)="$event.stopPropagation(); cancel_filter(prop)"
                  title="Effacer le filtre">cancel</mat-icon>

      </mat-form-field>
    </div>





    <!--      <button mat-icon-button (click)="clearFilter()" title="Effacer les filtres">-->
    <!--        <mat-icon>delete</mat-icon>-->
    <!--      </button>-->

    <div class="icon-buttons">
      <button mat-icon-button (click)="share()" aria-label="Partager"
              id="cmdShare"
              title="Partager le calendrier en envoyant un lien">
        <mat-icon>share</mat-icon>
      </button>
      <button mat-icon-button (click)="copy_calendar()"
              id="cmdCopy"
              aria-label="Copier" title="Copier le calendrier dans le presse-papier">

        <mat-icon>content_copy</mat-icon>
      </button>

      <button mat-icon-button (click)="exportToExcel()"
              id="cmdExcel"
              aria-label="Exporter Excel" title="Exporter le calendrier sous excel">
        <mat-icon>table_chart</mat-icon>
      </button>

      <button mat-icon-button (click)="print()"
              id="cmdPrint"
              aria-label="Imprimer" title="Imprimer le calendrier tel qu'à l'écran">
        <mat-icon>print</mat-icon>
      </button>

      <button mat-icon-button (click)="toggleTheme()"
              id="cmdTheme"
              title="Basculer sur le theme sombre / clair"
              [attr.aria-label]="isDarkTheme ? 'Passer au thème clair' : 'Passer au thème sombre'">
        <mat-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </button>



    </div>
    <div class="version">version: {{version}} by AF10</div>

  </div>
</div>

